import { render, staticRenderFns } from "./BlockType30.vue?vue&type=template&id=ce16e2b6&scoped=true"
import script from "./BlockType30.vue?vue&type=script&lang=ts"
export * from "./BlockType30.vue?vue&type=script&lang=ts"
import style0 from "./BlockType30.vue?vue&type=style&index=0&id=ce16e2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce16e2b6",
  null
  
)

export default component.exports